import graphqlClient from '@/graphql/graphql-client';
import { toPagingOnlyVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  ModelPricingssDocument,
  type ModelPricingssQuery,
} from '@/graphql/generated/graphql';

export type ModelPricingItem = NonNullable<
  NonNullable<ModelPricingssQuery['getModelPricingss']>['items']
>[number];
export type GetModelPricingsResponse = ModelPricingssQuery;

export const useGetModelPricings = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return useQuery({
    queryKey: ['model-pricings', variables],
    queryFn: () => graphqlClient.request(ModelPricingssDocument, variables),
  });
};

export const requestModelPricings = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return graphqlClient.request(ModelPricingssDocument, variables);
};

export const GET_MODEL_PRICINGS_QUERY = ModelPricingssDocument;
